// React
import React, {useState, useRef} from "react";

// Ant design
import { Button } from "antd";
import { PlusOutlined } from '@ant-design/icons';

// Eventify API
import * as EventifyAPI from "../libs/EventifyAPI";

// Local Storage
import {getCurrentUserId} from "../libs/UserContext";

export default function ListTableRowActions(props) {
  const myUserId = getCurrentUserId();
  const status = props.row.membership.status;
  const isSuggestion = status === 'addSuggestion' || status === 'deleteSuggestion';
  const isMySuggestion = (
    props.row.membership.userid === myUserId
    || props.row.membership.statusUserId === myUserId
  );
  const containerRef = useRef(null);

  const onUpdate = (diff) => {
    props.onUpdate({
      fromRow: props.idx,
      toRow: props.idx,
      updated: diff,
      action: true,
      name: props.name,
      email: props.email
    });
    // HACK: bug in chrome 74 (potentially others) where css doesn't repaint on render
    // (presumably because of how rdg handles their viewport/scrolling w/ padding)
    // this forces repaint
    setTimeout(() => {
      const current = containerRef.current;
      if (current) {
        const prevDisplay = current.parentNode.parentNode.style.display;
        current.parentNode.parentNode.style.display = "none";
        const offset = current.parentNode.parentNode.offsetLeft;
        current.parentNode.parentNode.style.display = prevDisplay;
      }
    }, 0);
  };

  return <div
    ref={containerRef}
    className="list-table-row-actions"
    title="Actions"
    // swallow events so rdg doesn't try to focus this row/cell
    onClick={(e) => e.stopPropagation()}
    onMouseDown={(e) => e.stopPropagation()}
    onMouseUp={(e) => e.stopPropagation()}
  >
    {/* check mark accept */}
    {isSuggestion && props.isListOwner &&
      <div
        className="action approve"
        title="Approve"
        onClick={() => {
          let isConfirmed = status === "deleteSuggestion" ? window.confirm("Remove " + props.row.name + " from the list?") : window.confirm("Add " + props.row.name + " to the list?");
          if (isConfirmed) {
            onUpdate({status: status === "addSuggestion" ? "approved" : "deleted"})
          }
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"><path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" /></svg>
      </div>
    }

    {/* // x ignore */}
    {isSuggestion && (props.isListOwner || isMySuggestion) &&
      <div
        className="action dismiss"
        title="Dismiss"
        onClick={() => {
          let isConfirmed = status === "addSuggestion" ? window.confirm("Are you sure you want to " + (isMySuggestion ? "remove" : "ignore") + " this suggestion?") : window.confirm("Are you sure you want to ignore this suggestion?");
          if (isConfirmed) {
            onUpdate({status: status === "addSuggestion" ? "deleted" : ""})
          }
        }}
      >
        <svg viewBox="0 0 9 9" width="9" height="9" xmlns="http://www.w3.org/2000/svg"><rect transform="rotate(-45 .82837 1.6284)" x=".82837" y="1.6284" width="1.1313" height="10.182"/><rect transform="rotate(225 1.6287 8.8284)" x="1.6287" y="8.8284" width="1.1313" height="10.182"/></svg>
      </div>
    }

    {/* // trash can delete or suggest deletion */}
    {!isSuggestion &&
      <div
        className="action delete"
        title="Delete"
        onClick={() => {
          let isConfirmed = props.isListOwner ? window.confirm("Remove " + props.row.name + " from list?") : window.confirm("Suggest removing " + props.row.name + " from list?");
          if (isConfirmed) {
            onUpdate({status: props.isListOwner ? "deleted" : "deleteSuggestion"})
          }
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"><path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" /></svg>
      </div>
    }

    {/* // trash can redact suggested removal */}
    {isSuggestion && isMySuggestion && !props.isListOwner && false &&
      <div
        className="action delete"
        title="Delete"
        onClick={() => {
          let isConfirmed = window.confirm("Remove your suggestion?");
          if (isConfirmed) {
            onUpdate({status: status === "addSuggestion" ? "deleted" : "" })
          }
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"><path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" /></svg>
      </div>
    }
  </div>
}
